import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material"
import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import { InputCheck } from "../../../../components/FormCommons"

import { EditableFormSection } from "../../../../components/forms/EditableFormSection"
import { useCompanyApi } from "../../events/api/useCompanyApi"
import {
  operation_types_mapping,
  operation_types_entries,
  operation_types_prefix,
} from "../register/RegisterCompanyFirstStep"
import { useTranslation } from "react-i18next"

export const CompanySectionServicesForm = ({
  control,
  watch,
  register,
}: any) => {
  const { t } = useTranslation()
  const val = watch("operation_types")
  const field = register("operation_types")
  const formContext = useFormContext()
  return (
    <>
      {operation_types_entries.map((entry, index) => {
        const on = val?.includes(entry.value)
        return (
          <FormGroup className="mb-4" key={index}>
            <FormControlLabel
              control={<Checkbox checked={on} />}
              label={t(entry.translationKey, entry.fallback)}
              onChange={(ev: any) => {
                var newVal = val
                  ? val.filter((v) => v !== entry.value)
                  : []
                if (ev.target.checked) {
                  newVal = [...newVal, entry.value]
                }
                formContext.setValue("operation_types", newVal)
              }}
            />
          </FormGroup>
          // <InputCheck
          //   // control={control}
          //   value={on}
          //   onChange={(ev) => {
          //
          //   }}
          //   label={type_key}
          //   // key={operation_types_mapping[type_key]}
          //   // name={`${operation_types_prefix}${operation_types_mapping[type_key]}`}
          // />
        )
      })}
    </>
  )
}

export const CompanySectionServicesPreview = ({ values }: any) => {
  const { t } = useTranslation()
  return (
    <div>
      <Typography marginX={4}>
        {operation_types_entries
          .filter((entry) =>
            values.operation_types?.includes(entry.value)
          )
          .map((entry) => t(entry.translationKey, entry.fallback))
          .join(", ") || "-"}
      </Typography>
    </div>
  )
}

export const CompanySectionServices = ({
  values,
  refetch,
  onSave,
}: {
  onSave?: Function
  values: any
  refetch: Function
}) => {
  const { t } = useTranslation()
  const { updateCompany } = useCompanyApi()
  const [val, setValue] = useState(values)

  const saveHandler = async (data: any) => {
    if (onSave) {
      return onSave(data)
    }
    var productData: any = {
      id: values.id,
      operation_types: data.operation_types,
    }
    return updateCompany(productData)
  }
  const handleRefresh = () => {
    refetch()
  }
  useEffect(() => {
    if (val.id !== values.id) {
      setValue(values)
    }
  }, [values])

  const update = (data: object) => {
    setValue(data)
  }
  return (
    <EditableFormSection
      title={t("Register.Business", "Zakres działalności")}
      values={val}
      onSave={saveHandler}
      onSaved={handleRefresh}
      onUpdate={update}
    >
      {(builderProps: any) => {
        return (
          <div>
            {builderProps.isEditing && (
              <CompanySectionServicesForm values={val} {...builderProps} />
            )}
            {!builderProps.isEditing && (
              <CompanySectionServicesPreview values={val} />
            )}
          </div>
        )
      }}
    </EditableFormSection>
  )
}
